// extracted by mini-css-extract-plugin
export default {"addToCartControl":"S3-z","giftCard":"T3-z","btnContainer":"U3-z","cartButton":"V3-z","disabled":"W3-z"};